import { render, staticRenderFns } from "./cancel-expired-investment-requests.vue?vue&type=template&id=5832e9e1&scoped=true&"
import script from "./cancel-expired-investment-requests.vue?vue&type=script&lang=js&"
export * from "./cancel-expired-investment-requests.vue?vue&type=script&lang=js&"
import style0 from "./cancel-expired-investment-requests.vue?vue&type=style&index=0&id=5832e9e1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5832e9e1",
  null
  
)

export default component.exports